<div class="dialog-title" *ngIf="formType == 'password'">Change Password</div>
<div class="dialog-title" *ngIf="formType == 'unblock'">Unblock User</div>
<form [formGroup]="formGrp" #formRef="ngForm">
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
            <mat-form-field>
                <input matInput [type]="visibility.new ? 'text' : 'password'" placeholder="New Password" required
                    autocomplete="off" formControlName="NewPassword">
                <button mat-button matSuffix mat-icon-button aria-label="show" type="button"
                    (click)="toggleVisibility('new')">
                    <mat-icon>{{ visibility.new ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error>
                    {{ getErrorMessage('NewPassword') }}
                </mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
            <mat-form-field>
                <input matInput [type]="visibility.confirm ? 'text' : 'password'" placeholder="Confirm New Password"
                    required autocomplete="off" formControlName="ConfirmPassword">
                <button mat-button matSuffix mat-icon-button aria-label="show" type="button"
                    (click)="toggleVisibility('confirm')">
                    <mat-icon>{{ visibility.confirm ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error *ngIf="formGrp.get('ConfirmPassword').hasError('required')">
                    Confirm Password is required.
                </mat-error>
                <mat-error
                    *ngIf="!formGrp.get('ConfirmPassword').hasError('required') && formGrp.get('ConfirmPassword').hasError('equalTo')">
                    Confirm password does not match.
                </mat-error>
            </mat-form-field>
        </div>

    </div>


    <div class="dialog-buttons">
        <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
        <button mat-button color="primary" (click)="submit(formGrp?.value)">Confirm</button>
    </div>
</form>